class Customer.CustomerSession extends Backbone.Model

  initialize: (attributes) ->
    @customerSessionId = attributes.customer_session_id
    @operatorId = attributes.operator_id
    @lastActivityTime = attributes.last_activity_time
